/* eslint-disable angular/no-private-call,angular/timeout-service */

export const timerHelperModule = angular
  .module('Q.helpers.timer-helper', [])

  .factory(
    'timerHelper',
    function ($rootScope, $window, $q, $exceptionHandler, $$q) {
      const deferreds = {};

      /**
       * Drop-in replacement for Angular's $timeout, but designed to run outside the framework a bit,
       * so it doesn't cause Angular to stay in a "non-stable" state for testing purposes.
       *
       * @param fn
       * @param delay
       * @param invokeApply
       * @param args
       */
      function longTimeout(fn, delay, invokeApply = true, ...args) {
        if (!angular.isFunction(fn)) {
          invokeApply = delay;
          delay = fn;
          fn = angular.noop;
        }

        const deferred = (invokeApply ? $q : $$q).defer();
        const promise = deferred.promise;
        let timeoutId;

        timeoutId = $window.setTimeout(function () {
          try {
            deferred.resolve(fn.apply(null, args));
          } catch (e) {
            deferred.reject(e);
            $exceptionHandler(e);
          } finally {
            delete deferreds[promise.$$timeoutId];
          }

          if (invokeApply) $rootScope.$apply();
        }, delay);

        promise.$$timeoutId = timeoutId;
        deferreds[timeoutId] = deferred;

        return promise;
      }

      /**
       * Cancels a previously configured longTimeout
       * @param promise Promise to cancel that was returned from longTimeout()
       * @returns {boolean}
       */
      longTimeout.cancel = function (promise) {
        if (promise && promise.$$timeoutId in deferreds) {
          // Timeout cancels should not report an unhandled promise.
          deferreds[promise.$$timeoutId].promise.catch(angular.noop);
          deferreds[promise.$$timeoutId].reject('canceled');
          delete deferreds[promise.$$timeoutId];
          return $window.clearTimeout(promise.$$timeoutId);
        }
        return false;
      };

      /**
       * Creates a recurring timer that is more guaranteed to run every [delay] milliseconds than $interval
       * @param fn Function to call on every tick
       * @param delay How often to run the timer
       * @param invokeApply Whether or not to invoke apply after each event
       * @param args Extra args passed to the function
       * @returns {{ stop, start, running }} An object that can be used to cancel the timer.
       */
      function runEvery(fn, delay, invokeApply = true, ...args) {
        let nextEventTime = Date.now() + delay;

        const ret = {
          stop() {
            runEvery.cancel(this);
          },
          start() {
            if (!this.running) {
              queueNextEvent();
            }
          },
        };

        function event() {
          // queue next event first, so it can be stopped/canceled by the timed event
          queueNextEvent();
          fn(...args);
        }

        function queueNextEvent() {
          if (ret.$$runEveryPromise) {
            runEvery.cancel(ret);
          }
          const now = Date.now();
          // determine the next trigger delay--skipping over any frames we've already passed if necessary
          while (nextEventTime < now) nextEventTime += delay;
          const eventDelay = nextEventTime - now;
          nextEventTime += delay;

          ret.$$runEveryPromise = longTimeout(event, eventDelay, invokeApply);
          event.running = true;
        }

        event();

        return ret;
      }

      /**
       * Cancels a runEvery event
       * @param event
       */
      runEvery.cancel = function (event) {
        if (event && event.$$runEveryPromise) {
          longTimeout.cancel(event.$$runEveryPromise);
          event.$$runEveryPromise = false;
          event.running = false;
        }
      };

      return {
        longTimeout,
        runEvery,
      };
    },
  );
